<template>
  <!-- Form -->

  <div
    class="daolgloth"
    :style="
      ischoiceId == '2' || dialogData.type == '1'
        ? 'height: 290px;'
        : 'height: 338px;'
    "
  >
    <el-tabs
      v-if="ischoiceId == '1'"
      :tab-position="tabPosition"
      style="height: 276px; background-color: #fff"
      stretch
    >
      <el-tab-pane label="微信登录">
        <!-- <img width="200" :src="qrUrl"/> -->
        <div id="qrcode" ref="qrcode" class="allse"></div>
        <p style="margin-top: 16px; text-align: center">
          <i class="el-icon-full-screen"></i> 微信扫码登录
        </p>
      </el-tab-pane>
      <el-tab-pane label="账号登录">
        <el-form
          ref="form"
          style="margin-top: 22px"
          :model="form"
          :rules="lrules"
          label-width="1px"
          class="accoutLogin"
        >
          <el-row class="propxinxin">
            <el-form-item label=" " prop="id" style="margin-left: 0">
              <el-input
                class="search-input"
                maxlength="11"
                placeholder="请输入用户名"
                v-model="form.id"
              />
            </el-form-item>
            <el-form-item
              label=" "
              prop="pw"
              style="margin-bottom: 8px; margin-left: 0"
            >
              <el-input
                type="password"
                class="search-input"
                placeholder="请输入密码"
                @keyup.enter.native.stop="login('form')"
                v-model="form.pw"
              />
            </el-form-item>
          </el-row>
        </el-form>
        <div class="CZMM">
          <span style="cursor: pointer" @click="wjmm">忘记密码</span>
        </div>
        <div class="dialog-footer">
          <el-button type="primary" @click="login('form')" class="anniu"
            >登录
          </el-button>
        </div>
        <p>
          没有账号？<span
            style="color: #e5ba35; cursor: pointer"
            @click="immediately"
            >立即注册</span
          >
        </p>
      </el-tab-pane>
      <el-tab-pane label="短信登录">
        <el-form
          style="margin-top: 22px"
          ref="loginForm"
          :model="form"
          :rules="rules"
          label-width="1px"
          class="login-box"
        >
          <!--suffix-icon="el-icon-mobile-phone"-->
          <el-form-item
            label=""
            prop="phoneNumber"
            class="phoneNumber"
            style="position: relative"
          >
            <el-input
              type="text"
              maxlength="11"
              placeholder="请输入手机号码"
              v-model="form.phoneNumber"
            /><span style="position: absolute; left: 15px; color: #333333"
              >+86</span
            >
          </el-form-item>
          <el-form-item label="" prop="code" style="position: relative">
            <!--  suffix-icon="el-icon-lock"-->
            <div class="verify-wrapper">
              <el-input
                type="text"
                maxlength="6"
                placeholder="请输入短信验证码"
                v-model="form.code"
              />
              <el-button
                style="position: absolute; right: 5px"
                type="text"
                class="btn-orange"
                :disabled="disabled"
                @click="getCode"
                >{{ valiBtn }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="dxloding"
              style="margin-top: 26px"
              class="anniu el-button el-button--primary"
              @click.prevent="onSubmit('loginForm')"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <!-- 双重身份的情况下 选择进入那个身份的个人中心 -->
    <div class="idtwogo" v-if="ischoiceId == '2'">
      <p>请选择登录身份</p>
      <div class="idtwogoname">
        <div>
          <img
            @click="choiceid(1)"
            style="border: 2px solid #f9bd00"
            :src="newIdMale"
            width="96"
            height="96"
          />
          <el-button
            type="text"
            @click="choiceid(1)"
            style="color: #f9bd00; margin-top: 6px"
            >接包方<span style="color: #333333">个人中心</span></el-button
          >
        </div>
        <div>
          <img
            @click="choiceid(2)"
            style="border: 2px solid #006afe"
            :src="newIdFemale"
            width="96"
            height="96"
          />
          <el-button
            type="text"
            @click="choiceid(2)"
            style="color: #006afe; margin-top: 6px"
            >发包方<span style="color: #333333">个人中心</span></el-button
          >
        </div>
      </div>
    </div>
    <!-- 当用户没有绑定手机号，进行扫码登录时触发显示 -->
    <component
      v-if="ischoiceId == '3'"
      :is="nophone"
      @isphone="isphone"
      @close="nophone = ''"
    />
    <!-- 注册弹窗 -->
    <component
      v-if="ischoiceId == '4'"
      :is="zhuece"
      :data="dialogData"
      @changeComponent1Data="component1DataChange"
    />
  </div>
</template>

<script>
import axios from "axios";
import { setToken, removeToken, getToken } from "@/utils/auth";
import { GetQRcode, setSelectType } from "../../api/projectSquare/xmgc";
// 生成二维码插件
import QRCode from "qrcodejs2";
import offphone from "./nophone";
import tancyg from "./newzhuce";

export default {
  name: "Login",
  components: {
    offphone,
    tancyg,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    loginType: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      const reg =
        /^0?(13[0-9]|15[012356789]|18[0-9]|14[578]|16[6]|17[035768]|19[0-9])[0-9]{8}$/;
      if (reg.test(value)) {
        return callback();
      }
      callback("手机号格式输入不正确");
    };
    return {
      qrUrl: process.env.API_ROOT + "wx/getQRCode",
      // 区分点击忘记密码还是返回登录
      differentiate: "",
      autoLogin: false,
      dxloding: false, // 短信登录 登录按钮loding
      cs: "",
      usertype: "",
      checked: true,
      tanchu: 0,
      rules: {
        phoneNumber: [
          {
            validator: checkPhone,
            required: true,
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      lrules: {
        id: [
          {
            validator: checkPhone,
            required: true,
            trigger: "blur",
          },
        ],
        pw: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false, // 对话框显示和隐藏
      valiBtn: "获取验证码",
      disabled: false,
      // 控制tab面板
      tabPosition: "top",

      //是否可以关闭
      canClose: false,
      //表单数据
      form: {
        id: "",
        pw: "",
        phoneNumber: "",
        code: "",
      },
      form1: {
        id: "",
        pw: "",
        phoneNumber: "",
        code: "",
      },
      isgogrzx: "0", // 是否去个人中心资质认证
      ischoiceId: "1", // 显示那个主要开关 1 登录 2 选择身份 3 没有绑定手机号码页面 4 注册弹窗
      nophone: "offphone", // 无绑定手机号页面
      zhuece: "tancyg",
      dialogData: {}, // 注册页面
      openid: "", // openid
      newIdMale: "", // 接包方使用头像
      newIdFemale: "", // 发包方使用头像
    };
  },
  created() {
    if (this.loginType) {
      this.creatQrCode();
    }
  },
  methods: {
    // 跳转历史网页
    toRedirectPath() {
      let redirectPath = sessionStorage.getItem("redirectPath");
      if (redirectPath) {
        const [baseUrl, hashPart] = redirectPath.split("#");

        if (hashPart) {
          const [hashPath, queryString] = hashPart.split("?");
          const params = new URLSearchParams(queryString);

          // 仅当 token 为 "undefined" 时，才替换为 getToken() 的值
          if (params.get("token") === "undefined") {
            params.set("token", getToken());
          }

          redirectPath = `${baseUrl}#${hashPath}${
            params.toString() ? "?" + params.toString() : ""
          }`;
        }

        window.open(redirectPath);
      }
    },
    // 调用生成二维码插件方法
    creatQrCode() {
      GetQRcode()
        .then((response) => {
          // console.log(response,"二维码")
          removeToken();
          this.$refs.qrcode.innerHTML = ""; //清除二维码方法一
          let text = response.data.codedata.url;
          localStorage.setItem("scene", JSON.stringify(response.data));
          var qrcode = new QRCode(this.$refs.qrcode, {
            text: text, //页面地址 ,如果页面需要参数传递请注意哈希模式#
            width: 200,
            height: 200,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
          let scene = JSON.parse(localStorage.getItem("scene"));
          // 需要消息的推送，则创建连接
          this.createWebSocket(scene.sceneId);
        })
        .catch((response) => {});
    },

    // 与websocket服务器创建连接
    createWebSocket(userId) {
      let that = this;
      let websocket = new WebSocket(
        process.env.WebSocket_ROOT + "webSocket/" + userId
      );
      // 连接成功时
      websocket.onopen = () => {
        // websocket.send('hello')
      };
      websocket.onmessage = (event) => {
        // 后端发送的消息在event.data中,进行提醒
        let jsonList = JSON.parse(event.data); // 转换
        if (
          jsonList.token === null ||
          jsonList.token === undefined ||
          jsonList.token === ""
        ) {
          this.ischoiceId = "3";
          this.openid = jsonList.openid;
        } else {
          setToken(jsonList.token);
          sessionStorage.setItem("is_login", "true");
          localStorage.setItem("userId", jsonList.id);
          // 判断是否选择身份和如果有身份跳接包方(1)还是发包方(2)的个人中心
          sessionStorage.setItem("usertype", jsonList.userRegistrationTypes);
          let userType = jsonList;
          const level = jsonList.levelSign;
          sessionStorage.setItem("level", jsonList.levelSign);
          if (this.loginType === 1) {
            that.choiceid(1);
            that.guanbidenl();
            // location.href='/purchaseMembership'
            return;
          }
          if (Number(level) === 0) {
            that.choiceid(1);
            that.guanbidenl();
          } else {
            that.judgeCenter(that.$route.path, userType);
          }
          // that.judgeCenter(that.$route.path, userType);
        }
      };
      websocket.onclose = function () {
        // console.log("关闭了");
      };
      // // 路由跳转时结束websocket链接
      this.$router.afterEach(function () {
        websocket.close();
      });
      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常
      window.onbeforeunload = function () {
        websocket.close();
      };
    },

    asduai() {
      this.$emit("immediatelyData", this.differentiate, this.cs, this.usertype);
    },
    // 立即注册
    immediately() {
      this.differentiate = "0";
      this.asduai();
    },
    // 忘记密码
    wjmm() {
      this.differentiate = "1";
      this.asduai();
      this.$router.push("/forgetPassword.html");
    },
    guanbidenl() {
      this.differentiate = "2";
      this.asduai();
    },
    // immediatelyData(artlf){
    //   this.tanchu= artlf
    // },

    //登录
    login: function () {
      //这里使用的是固定的用户名和密码。admin/111111
      //校验密码
      if (this.form.pw.trim() == "" || this.form.id.trim() == "") {
        this.$message.error("请填写手机号码和密码！");
        return;
      } else {
        var that = this;
        var formData = {};
        this.$set(formData, "phoneNumber", this.form.id);
        this.$set(formData, "password", this.form.pw);
        removeToken();
        axios.post("/website/account/signIn", formData).then(function (res) {
          if (res.data.code == 200 || res.code == 200) {
            console.log(res.data, "res.datares.datares.data");
            if (res.data.audit) {
              // that.$router.push("/userCheck");
              that.$router.push({
                path: "/userCheck",
                query: { audit: res.data.audit },
              });
              that.guanbidenl();
            } else {
              //把登录数据写入到session
              if (window.sessionStorage) {
                // console.log(res.data.data,"登录信息");
                sessionStorage.setItem("is_login", "true");
                that.cs = res.data.data.id;
                that.usertype = res.data.data.userRegistrationTypes;

                // 存ID
                localStorage.setItem("userId", res.data.data.id);
                sessionStorage.setItem("userName", res.data.data.userName);
                sessionStorage.setItem("level", res.data.data.levelSign);
                // 存个人中心的身份
                sessionStorage.setItem(
                  "usertype",
                  res.data.data.userRegistrationTypes
                );
                // 存电话
                sessionStorage.setItem(
                  "Mobilephone",
                  res.data.data.phoneNumber
                );
                sessionStorage.setItem("userName", res.data.data.userName);
                // 存头像
                sessionStorage.setItem(
                  "Headportrait",
                  res.data.data.headPortrait
                );
                // console.log(res.data.data.phoneNumber,"这是手机号")
              }
              setToken(res.data.data.token);

              that.$message({
                type: "success",
                message: "登录成功!",
              });
              // 账号审核  1审核中
              let userType = res.data.data;
              const level = res.data.data.levelSign;
              if (that.loginType === 1) {
                that.choiceid(1);
                that.guanbidenl();
                // location.href = '/purchaseMembership'
                return;
              }

              if (Number(level) === 0) {
                that.choiceid(1);
                that.guanbidenl();
                // location.reload();
              } else {
                that.judgeCenter(that.$route.path, userType);
              }
              // // 判断是否选择身份和如果有身份跳接包方(1)还是发包方(2)的个人中心
              // if (res.data.data.userRegistrationTypes == "1") {
              //   // 去接包方个人中心
              //   location.href = "/acpUser/acpUserBaseInfo/acpUserIndex";
              //   // that.$router.push('/acpUser/acpUserInfo')
              // } else if (res.data.data.userRegistrationTypes == "2") {
              //   // 去发包方个人中心
              //   location.href = "/empUser/empCa/empCertification";
              //   // that.$router.push('/empUser/empUserInfo')
              // } else {
              //   // 没得身份，去选择身份页面
              //   location.href = "/Selectthe.html";
              //   // that.$router.push('/Selectthe.html')
              // }
              // 判断是否选择身份和如果有身份跳接包方(1)还是发包方(2)的个人中心
              // let userType = res.data.data.userRegistrationTypes;
              // if (userType !== "1" && userType !== "2") {
              //   // 没得身份，去选择身份页面
              //   location.href = "/Selectthe.html";
              //   // that.$router.push('/Selectthe.html')
              // }else{
              //   location.reload();  // 如果已有身份则刷新页面，刷新页面登录后的数据更新
              // }

              // 关闭登录
              // that.guanbidenl();
            }
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }
    },

    //获取验证码
    //获取验证码 并只验证手机号 是否正确
    getCode() {
      var that = this;
      this.$refs["loginForm"].validateField("phoneNumber", (err) => {
        if (err) {
          // console.log("未通过");
          return;
        } else {
          this.tackBtn(); //验证码倒数60秒
          /*let fd = new FormData(); //POST 请求需要 转化为Form
          fd.append('PhoneNumber', this.form.phoneNumber);
          fd.append('NeedCheck', 2);*/
          var phone = that.form.phoneNumber;
          axios.get("/website/sendCode/" + phone + "/3").then(function (res) {
            // console.log(res);
            if (res.data.code == 200) {
              that.$message({
                type: "success",
                message: "验证码已发送!",
              });
            } else {
              that.$message.error(res.data.msg);
              return false;
            }
          });
        }
      });
    },
    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = "获取验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.valiBtn = time + "秒后重试";
          time--;
        }
      }, 1000);
    },
    // 短信登录
    onSubmit(formName) {
      //点击登录 验证手机& 验证码是否符合条件
      let that = this;
      that.dxloding = true;
      that.$refs[formName].validate((valid) => {
        // 为表单绑定验证功能
        if (valid) {
          let formData = {};
          that.$set(formData, "phoneNumber", that.form.phoneNumber);
          that.$set(formData, "telephoneCode", that.form.code);
          removeToken();
          axios.post("/website/message/signIn", formData).then((res) => {
            if (res.data.code == 200) {
              if (res.data.audit) {
                that.$router.push({
                  path: "/userCheck",
                  query: { audit: res.data.audit },
                });
                that.guanbidenl();
              } else {
                //把登录数据写入到session
                if (window.sessionStorage) {
                  console.log(res, "短信登录");
                  sessionStorage.setItem("is_login", "true");
                  // sessionStorage.setItem("userId", JSON.stringify(res.data.data.id));
                  (that.cs = res.data.data.id),
                    (that.usertype = res.data.data.userRegistrationTypes),
                    // 存ID
                    localStorage.setItem("userId", res.data.data.id);
                  // 存个人中心的身份
                  sessionStorage.setItem(
                    "usertype",
                    res.data.data.userRegistrationTypes
                  );
                  // 存电话
                  sessionStorage.setItem(
                    "Mobilephone",
                    res.data.data.phoneNumber
                  );
                  sessionStorage.setItem("userName", res.data.data.userName);

                  // sessionStorage.setItem(
                  //   "userName",
                  //   res.data.data.userName
                  // );
                  // 存头像
                  sessionStorage.setItem(
                    "Headportrait",
                    res.data.data.headPortrait
                  );
                }
                setToken(res.data.data.token);

                that.$message({
                  type: "success",
                  message: "登录成功!",
                });

                let userType = res.data.data;
                const level = res.data.data.levelSign;
                sessionStorage.setItem("level", res.data.data.levelSign);
                if (this.loginType === 1) {
                  this.choiceid(1);
                  this.guanbidenl();
                  return;
                }

                if (Number(level) === 0) {
                  this.choiceid(1);
                  that.guanbidenl();
                } else {
                  that.judgeCenter(that.$route.path, userType);
                }
                // that.judgeCenter(that.$route.path, userType); // 这个是登录成功跳转的方法
              }
            } else {
              that.$message.error(res.data.msg);
            }
            this.dxloding = false;
          });
        } else {
          this.dxloding = false;
          that.dialogVisible = true;
          return false;
        }
      });
    },

    // 判断是否需要跳转到个人中心
    /*
      isroute 路由
      intype  顾客类型 ['1','2'] 数组里只有1 是接包方，只有2是发包方，1，2都存在是双重身份 // 修改成 返回这个返回的所有字段
    */
    judgeCenter(isroute, intype) {
      localStorage.removeItem("listNameMun"); // 清除 发包方 缓存的table选择值
      /*  目前需要 登录后不跳 个人中心的
        '/Detailsonthesquare'  项目详情
        ’/classUtils/studyClass‘ 课程详情
        '/packagedetails'  任务包名称
      */

      // headPortrait: null // 头像
      // headStatus: 3  // 1：上传了头像  2：男  3：女  4：默认

      // 判断是否选择身份和如果有身份跳接包方(1)还是发包方(2)的个人中心

      sessionStorage.setItem("usertype", intype.userRegistrationTypes);
      if (
        intype.userRegistrationTypes &&
        intype.userRegistrationTypes.length > 0
      ) {
        // 有身份条件下
        if (intype.userRegistrationTypes.length > 1) {
          // 双重身份的情况下
          if (intype.headStatus == 1) {
            this.newIdMale = intype.headPortrait; // 接包方使用头像
            this.newIdFemale = intype.headPortrait; // 发包方使用头像
          } else if (intype.headStatus == 2) {
            this.newIdMale = require("../../assets/image/newjiebao.png"); // 接包方使用头像
            this.newIdFemale = require("../../assets/image/newfabao.png"); // 发包方使用头像
          } else if (intype.headStatus == 3) {
            this.newIdMale = require("../../assets/image/newjiebaonv.png"); // 接包方使用头像
            this.newIdFemale = require("../../assets/image/newfabaonv.png"); // 发包方使用头像
          } else if (intype.headStatus == 4) {
            this.newIdMale = require("../../assets/image/newjiebaowu.png"); // 接包方使用头像
            this.newIdFemale = require("../../assets/image/newfabaowu.png"); // 发包方使用头像
          }
          this.choiceid(1);
          // this.ischoiceId = '2'; // 将选择进入用户中心-弹窗打开
        } else {
          // 只有单个身份
          let kejq = isroute.split(".html")[0]; // 截取.html前的地址来进行判断
          if (
            kejq === "/Detailsonthesquare" ||
            kejq === "/classUtils/studyClass" ||
            kejq === "/packagedetails"
          ) {
            // 不跳转
            location.reload(); // 如果已有身份则刷新页面，刷新页面登录后的数据更新
          } else {
            // 都去个人中心
            if (intype.userRegistrationTypes[0] === "1") {
              // 去接包方个人中心
              if (this.data.looke && this.data.looke === "1") {
                location.href = "/acpUser/acpUserBaseInfo/ca/certification";
                return;
              } else {
                location.href = "/acpUser/acpUserBaseInfo/acpUserIndex";
                return;
              }
            } else if (intype.userRegistrationTypes[0] === "2") {
              // 去发包方个人中心
              location.href = "/empUser/empCa/accountIndex";
              return;
            }
          }
          this.choiceid(1);

          // 关闭登录
          this.guanbidenl();
        }
      } else {
        // 无任何身份条件下
        // 关闭登录
        sessionStorage.setItem("level", 0);
        this.choiceid(1);
        this.guanbidenl();

        // 没得身份，去选择身份页面
        // location.href = "/Selectthe.html";
      }

      // let kejq = isroute.split('.html')[0]; // 截取.html前的地址来进行判断
      // if(intype === 99999999999){ // 当用户即是发包方又是接包方时 -----判断值按照后台的来定制
      //   this.ischoiceId = true; // 将选择用户弹窗打开
      // }else{ // 若只是单接包方或发包方
      //   if (kejq === '/Detailsonthesquare' || kejq === '/classUtils/studyClass' || kejq === '/packagedetails'){  // 不跳转
      //     if (intype !== "1" && intype !== "2") {
      //       // 没得身份，去选择身份页面
      //       location.href = "/Selectthe.html";
      //     }else{
      //       location.reload();  // 如果已有身份则刷新页面，刷新页面登录后的数据更新
      //     }
      //   }else{ // 都去个人中心
      //     if (intype == "1") {
      //       // 去接包方个人中心
      //       if(this.data.looke && this.data.looke === '1'){
      //         location.href = "/acpUser/acpUserBaseInfo/ca/certification";
      //       }else{
      //         location.href = "/acpUser/acpUserBaseInfo/acpUserIndex";
      //       }
      //     } else if (intype == "2") {
      //       // 去发包方个人中心
      //       location.href = "/empUser/empCa/accountIndex";
      //     } else {
      //       // 没得身份，去选择身份页面
      //       location.href = "/Selectthe.html";
      //     }
      //   }
      // }
    },

    // 用户选择接包方或者发包方是的点击事件
    /*
      type 2为发包方  1为接包方
    */
    choiceid(type) {
      setSelectType(type).then((res) => {
        removeToken();
        setToken(res.data);
        this.toRedirectPath();
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        setTimeout((e) => {
          if (this.loginType === 1) {
            location.href = "/purchaseMembership";
            loading.close();
            return;
          }
          if (type == 1) {
            // 去接包方个人中心
            if (this.data.looke && this.data.looke === "1") {
              location.href = "/acpUser/acpUserBaseInfo/ca/certification";
            } else {
              location.href = "/acpUser/acpUserBaseInfo/acpUserIndex";
            }
          } else if (type == 2) {
            // 去发包方个人中心
            location.href = "/empUser/empCa/accountIndex";
          }
          loading.close();
        }, 1000);
      });
    },

    // 注册完成或 注册返回登录
    /*
    1  返回扫码
    2  注册完成关闭弹窗
    */
    component1DataChange(params) {
      if (params === 1) {
        this.ischoiceId = "1"; // 未注册完成 返回到扫码登录
        this.creatQrCode();
      } else {
        this.guanbidenl(); // 注册完成 关闭直接进入选择身份页面
      }
    },

    // 没有绑定手机号绑定后返回
    /*
    1: 绑定已有账号
    2: 注册新账号
    3: 返回重新扫码
    */
    isphone(type) {
      if (type === 1) {
        this.ischoiceId = "4";
        this.dialogData = {
          type: "1",
          openid: this.openid,
        };
      } else if (type === 2) {
        this.ischoiceId = "4";
        this.dialogData = {
          type: "2",
          openid: this.openid,
        };
      } else if (type === 3) {
        this.ischoiceId = "1";
        this.creatQrCode();
      }
    },
  },
};
</script>
<style scoped>
.verify-wrapper .el-button--text {
  color: #f9bd01;
}

.daolgloth >>> .el-tabs__header {
  margin-bottom: 0;
}

.accoutLogin >>> .el-form-item__label {
  height: 0;
}

.allse {
  box-sizing: border-box;
  width: 217px;
  height: 217px;
  border: 1px solid #e4e4e4;
  margin: 16px auto 0;
  padding: 8px;
  border-radius: 4px;
}

/*去掉el-tab-pane底部灰色线条*/
.daolgloth >>> .el-tabs__nav-wrap::after {
  height: 0;
}

/*去掉el-tab-pane切换时的蓝色下划线*/
.daolgloth >>> .el-tabs__active-bar {
  background: transparent;
}

.phoneNumber >>> .el-input__inner {
  padding-left: 45px;
}

.daolgloth >>> .el-tabs__item {
  font-size: 16px;
  color: #999999;
  font-weight: normal;
  line-height: unset;
}

.daolgloth >>> .el-tabs__nav.is-stretch {
  align-items: baseline;
}
</style>
<style scoped>
.allse img {
  margin: 0 auto;
}

.anniu {
  width: 100%;
  color: #333;
  background-color: #f9bd00;
  border-color: #f9bd00;
}

.CZMM {
  text-align: right;
  width: 100%;
  margin-bottom: 20px;
  color: #868686;
}

.CZMM span {
  margin-right: 2px;
}

.gunib {
  position: absolute;
  top: 0.425rem;
  right: 0.625rem;
  font-size: 1.75rem;
  cursor: pointer;
}

.verify-wrapper {
  display: flex;
}

.daolgloth {
}

.daolgloth .el-dialog__body {
  padding: 17px 60px;
}

.daolgloth .el-tabs__active-bar {
  background-color: #f9bd00;
}

.daolgloth /deep/ .el-tabs__item.is-active {
  color: #000000;
  font-size: 20px;
}

.propxinxin .el-form-item__label:before {
  content: "" !important;
  color: #f56c6c;
  margin-right: 7px;
}

.idtwogo {
}

.idtwogoname {
  display: flex;
  align-items: center;
}

.idtwogoname img {
  border-radius: 10px;
  cursor: pointer;
}

.idtwogo p {
  margin: 0;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/denlu/zhesdengl.vue